module.exports = __webpack_public_path__ + "434981ce9496adebc0bcb3071c86fc45.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/paywalls/quiz-features.png
// module id = 2727
// module chunks = 0